import inflection from "inflection";

export const inflectQuantity = (quantity: string, form: string): string => {
  return inflection.inflect(`${quantity} ${form}`, quantity);
};

export const extractNumber = (quantity: string): string => {
  return quantity?.replace(/[^0-9]+/g, "");
};
